export const isScriptLoaded = (url)=>{
    const scripts = document.querySelectorAll(`script[src='${url}']`);
    return scripts.length > 0;
};
/**
 * Loads a script into the DOM asynchronously
 */ export const loadScript = async (url)=>{
    return new Promise((resolve, reject)=>{
        if (isScriptLoaded(url)) return resolve();
        const ref = document.getElementsByTagName('script')[0];
        const script = document.createElement('script');
        script.src = url;
        script.onload = ()=>resolve()
        ;
        script.onerror = ()=>reject()
        ;
        ref.parentNode.insertBefore(script, ref);
    });
};
/**
 * Loads an array of scripts into the DOM
 */ export const loadScripts = async (urls)=>{
    return Promise.all(urls.map(loadScript));
};

//# sourceMappingURL=load-script.js.map